import PropTypes from "prop-types";

const gridContextPropTypeObject = {
  filters: PropTypes.string,
  type: PropTypes.string,
  grid_id: PropTypes.string,
  nth_style: PropTypes.number,
  page: PropTypes.number,
  page_max: PropTypes.number,
  personalization_location: PropTypes.string,
  sort_type: PropTypes.string,
};

// This is what's expected in the gridContext object. It is what's saved in LS/Redux and used in the next page the user goes to
export const gridContextPropType = PropTypes.shape(gridContextPropTypeObject);

// This is a combination of grid and carousel and is what's expected in the analyticsPreviousLocationContext object
export const gridAndCarouselContextPropType = PropTypes.shape({
  ...gridContextPropTypeObject,
  carousel_id: PropTypes.string,
  nth_carousel: PropTypes.number,
  request_id: PropTypes.string,
  style_name: PropTypes.string,
});
